import React from 'react';
import MetaComponent from '../../Components/MetaComponent';
import {
  POLICY_TEXT_2,
  POLICY_TEXT_3,
  POLICY_TEXT_4,
  POLICY_TEXT_5,
  POLICY_TEXT_6,
  POLICY_TEXT_7,
  POLICY_TEXT_8,
  POLICY_TEXT_9,
  POLICY_TEXT_10,
  POLICY_TEXT_11,
  POLICY_TEXT_12,
  POLICY_TEXT_13,
  POLICY_TEXT_14,
  POLICY_TEXT_15,
  POLICY_TEXT_16,
  POLICY_TEXT_17,
  POLICY_TEXT_18,
  POLICY_TEXT_19,
  POLICY_TEXT_20,
  POLICY_TEXT_21,
  POLICY_TEXT_22,
  POLICY_TEXT_23,
  POLICY_TEXT_24,
  POLICY_TEXT_25,
  POLICY_TEXT_26,
  POLICY_TEXT_27,
  POLICY_TEXT_28,
  POLICY_TEXT_29,
  POLICY_TEXT_30,
  POLICY_TEXT_31,
  POLICY_TEXT_32,
  POLICY_TEXT_0
} from '../../constants';
import styles from './PrivacyPolicy.module.css';

const metaDescription = 'Privacy Policy related to usage of the Sociana App';
const PrivacyPolicy = () => (
  <>
    <MetaComponent
      title="Privacy Policy: Alien Brains"
      description={metaDescription}
      url="https://alienbrains.in/privacy_policy"
    />
    <div className={styles.container}>
      <div className={styles.heading}>
        <h1 className="headingText">{POLICY_TEXT_0}</h1>
      </div>
      <section className={styles.content}>
        <div className="bodyText">
          <p>{POLICY_TEXT_2}</p>
          <p>{POLICY_TEXT_3}</p>
          <p>{POLICY_TEXT_4}</p>
          <p className="headingNormalText">{POLICY_TEXT_5}</p>
          <p className={styles.content_text}>{POLICY_TEXT_6}</p>
          <p className={styles.content_text}>{POLICY_TEXT_7}</p>
          <p className={styles.content_text}>{POLICY_TEXT_8}</p>
          <ul>
            <li>
              <a href="https://www.google.com/policies/privacy/">
                {POLICY_TEXT_9}
              </a>
            </li>
          </ul>
          <p className="headingNormalText">{POLICY_TEXT_10}</p>
          <p>{POLICY_TEXT_11}</p>
          <p className="headingNormalText">{POLICY_TEXT_12}</p>
          <p>{POLICY_TEXT_13}</p>
          <p>{POLICY_TEXT_14}</p>
          <p className="headingNormalText">{POLICY_TEXT_15}</p>
          <p>{POLICY_TEXT_16}</p>
          <ul>
            <li>{POLICY_TEXT_17}</li>
            <li>{POLICY_TEXT_18}</li>
            <li>{POLICY_TEXT_19}</li>
            <li>{POLICY_TEXT_20}</li>
          </ul>
          <p>{POLICY_TEXT_21}</p>
          <p className="headingNormalText">{POLICY_TEXT_22}</p>
          <p>{POLICY_TEXT_23}</p>
          <p className="headingNormalText">{POLICY_TEXT_24}</p>
          <p>{POLICY_TEXT_25}</p>
          <p className="headingNormalText">{POLICY_TEXT_26}</p>
          <p>{POLICY_TEXT_27}</p>
          <p className="headingNormalText">{POLICY_TEXT_28}</p>
          <p>{POLICY_TEXT_29}</p>
          <p className="headingNormalText">{POLICY_TEXT_30}</p>
          <p>
            {POLICY_TEXT_31}
            <a href={`mailto:${POLICY_TEXT_32}`}>{POLICY_TEXT_32}</a>
          </p>
        </div>
      </section>
    </div>
  </>
);
export default PrivacyPolicy;
